module.exports = __webpack_public_path__ + "static/media/vendas.774f5cf1.svg";